import React, { useEffect, useRef, useState } from "react";
import "./style/SlideIn.css"; // Make sure your CSS is imported

export default function SlideIn({ children }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(ref.current); // animate only once
        }
      },
      { threshold: 0.1 } // trigger when 10% visible
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`slide-in ${visible ? "visible" : ""}`}>
      {children}
    </div>
  );
}
